import React from 'react'

import Loading from '../items/Loading'
import Modal from './Modal'

/**
 * ローディングモーダル
 */
const LoadingModal: React.FC<LoadingModalProps> = (props) => {
  return (
    <Modal on={props.on} scrollLock greyBack type="center">
      <Loading />
    </Modal>
  )
}

type LoadingModalProps = {
  on: boolean
}

export default React.memo<LoadingModalProps>(LoadingModal)
